<template>
  <div id="dashboard-analytics">
    <div class="vx-row">

      <!-- CARD 2: Registered Users -->
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <statistics-card-line icon="UsersIcon" v-if="salesBarSession.registered_users" :statistic="salesBarSession.registered_users" statisticTitle="Registered Users" :chartData="fakeData1" type='area'></statistics-card-line>
      </div>

      <!-- CARD 3: Daily logins -->
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <statistics-card-line icon="ShoppingBagIcon"  v-if="salesBarSession.registered_users" :statistic="salesBarSession.daily_login_count" statisticTitle="Daily logins" :chartData="fakeData1" color='warning' type='area'></statistics-card-line>
      </div>
    
      <!-- CARD 4: SESSION -->
      <div class="vx-col w-full md:w-1/2 mb-base">
        <vx-card>
          <vs-divider class="my-6"></vs-divider>
          <div class="vx-row">
            <div class="vx-col w-1/2 mb-3" v-for="(item,index) in lines" :key="index">
              <p>{{item.label}}: {{numberWithComma(item.value)}}</p>
              <vs-progress class="block mt-1" :percent="line[index]" :color="colors[index]"></vs-progress>
            </div>            
          </div>
        </vx-card>
      </div>
    </div>
  
    <div class="vx-row" v-if="salesBarSession.total_buy_percentage">
        <!-- CARD 6: Product Orders -->
        <div class="vx-col w-full lg:w-1/3 mb-base">
            <vx-card title="Buy statistics">
                <!-- Chart -->
                <div slot="no-body">
                    <vue-apex-charts type=radialBar height=420 :options="chartOptions(salesBarSession.total_buy_percentage)" :series="productsOrdersBuy.series" />
                </div>

                <ul>
                    <li v-for="orderData in productsOrdersBuy.analyticsData" :key="orderData.orderType" class="flex mb-3 justify-between">
                        <span class="flex items-center">
                                <span class="inline-block h-4 w-4 rounded-full mr-2 bg-white border-3 border-solid" :class="`border-${orderData.color}`"></span>
                                <span class="font-semibold">{{ orderData.orderType }}</span>
                        </span>
                        <span>{{ orderData.counts }}</span>
                    </li>
                </ul>
            </vx-card>
        </div>
        <!-- CARD 7: Product Orders -->
        <div class="vx-col w-full lg:w-1/3 mb-base">
            <vx-card title="Sell statistics">
                <!-- Chart -->
                <div slot="no-body">
                    <vue-apex-charts type=radialBar height=420 :options="chartOptions(salesBarSession.total_sell_percentage)" :series="productsOrdersSell.series" />
                </div>

                <ul>
                    <li v-for="orderData in productsOrdersSell.analyticsData" :key="orderData.orderType" class="flex mb-3 justify-between">
                        <span class="flex items-center">
                                <span class="inline-block h-4 w-4 rounded-full mr-2 bg-white border-3 border-solid" :class="`border-${orderData.color}`"></span>
                                <span class="font-semibold">{{ orderData.orderType }}</span>
                        </span>
                        <span>{{ orderData.counts }}</span>
                    </li>
                </ul>
            </vx-card>
        </div>
        <div class="vx-col w-full lg:w-1/3 mb-base">
          <vx-card id="clock">
            <div class="vx-row">
              <div class="vx-col w-1/2">
                <AnalogClock :size="200" handType="line" :borderWidth="10" :time="ukTime" ref="ac1"/>
                <center><b>UK</b></center>
              </div>
              <div class="vx-col w-1/2" >
                <AnalogClock :size="200" handType="line" :borderWidth="10" :time="ilTime" ref="ac2"/>
                <center><b>IL</b></center>
              </div>
            </div>
          </vx-card>
        </div>
    </div>
    <vx-card no-shadow>
      <h3>Deposits</h3>
      <vs-table max-items="5" pagination :data="tableData">
          <template slot="thead">
              <vs-th v-for="(item,index) in fieldsHead" :key="index">{{item}}</vs-th>
          </template>

          <template slot-scope="{data}">
              <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                <vs-td  v-for="(item,index) in fieldsHead" :key="index" :data="data[indextr][item]">
                      {{data[indextr][item]}}
                  </vs-td>
              </vs-tr>
          </template>
      </vs-table>
    </vx-card>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
import ChangeTimeDurationDropdown from '@/components/ChangeTimeDurationDropdown.vue'
import VxTimeline from "@/components/timeline/VxTimeline"
import {AnalogClock} from 'vue-analog-clock'
import axios from "@/axios.js"


export default {
    data() {
        let event = new Date();       
        let data =  {
            lines:[],
            colors:['success','primary','warning','danger'],
            tableData:[],
            fieldsHead: [],
            ukTime: event.toLocaleString('en-GB', { timeZone: 'Europe/London' }).split(' ')[1],
            ilTime: event.toLocaleString('en-GB', { timeZone: 'Asia/Jerusalem' }).split(' ')[1],
            line:[],
            week: ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'],
            checkpointReward: {},
            ordersRecevied: {},
            fakeData1:[{data:[8,16,9,15,7,18,10]}],
            fakeData2:[{data:[8,16,9,15,7,18,10]}],
            salesBarSession: {},
            supportTracker: {},
            productsOrdersBuy: {},
            productsOrdersSell: {},
            salesRadar: {},
            dispatchedOrders: [],
        }
        for(let i=0;i<7;i++){
          data.line.push(Math.floor(Math.random() * 100));
        }
        return data;
    },
    components: {
        VueApexCharts,
        StatisticsCardLine,
        ChangeTimeDurationDropdown,
        VxTimeline,
        AnalogClock
    },
    created() {
      // Sales bar - Analytics
      this.$http.get("/api/dashboard")
        .then((response) => { 
          this.salesBarSession = response.data;
          //console.log(response.data)
          this.lines.splice(0);
          for(let i in this.salesBarSession){
            this.lines.push({label:i,value:this.salesBarSession[i]});
          }
          this.productsOrdersBuy= {
            analyticsData: [
                { 'orderType': 'Percentage', 'counts': response.data.total_buy_percentage.replace('%',''), color: 'primary' },
                { 'orderType': 'Daily', 'counts': this.numberWithComma(response.data.daily_buy_volume.replace(' EUR',''))+' EUR', color: 'warning' },
                { 'orderType': 'Total ', 'counts': this.numberWithComma(response.data.total_buy_volume.replace(' EUR',''))+' EUR', color: 'danger' },
            ],
            series: [response.data.total_buy_volume.replace(' EUR',''), response.data.daily_buy_volume.replace(' EUR',''),response.data.total_buy_percentage.replace('%','')],
            counts: response.data.total_buy_percentage
          };
          this.productsOrdersSell= {
            analyticsData: [
                { 'orderType': 'Percentage', 'counts': response.data.total_sell_percentage.replace('%',''), color: 'primary' },
                { 'orderType': 'Daily', 'counts': this.numberWithComma(response.data.daily_sell_volume.replace(' EUR',''))+' EUR', color: 'warning' },
                { 'orderType': 'Total ', 'counts': this.numberWithComma(response.data.total_sell_volume.replace(' EUR',''))+' EUR', color: 'danger' },
            ],
            series: [response.data.total_sell_volume.replace(' EUR',''), response.data.daily_sell_volume.replace(' EUR',''),response.data.total_sell_percentage.replace('%','')],
            counts: response.data.total_sell_percentage
          }           
          })
        .catch((error)   => { console.log(error) })
    },
    mounted(){
      this.setExchangeBalance();
        //let ac1 = this.$refs.ac1;
        //ac1.run();
        //let ac2 = this.$refs.ac2;
        //ac2.run();
        //如果props没有传入time,那么会默认执行run方法
        // 
        // ac.stop();
    },
    methods: {
      setExchangeBalance: function(){
        let that = this;
        axios.post("/api/dashboard-balance")
        .then((response) => {
          that.tableData.splice(0);
          for(let i in response.data){
            let data = JSON.parse(response.data[i].object);
            if(that.fieldsHead.length===0){
                for(let i in data){
                    that.fieldsHead.push(i);
                }
            }
            that.tableData.push(data);
          }
        })
        .catch((error) => { console.log('error',error) })
      },
      numberWithComma:function(x){
        if(x===undefined || x===null)
          return;
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',');
      },
      chartOptions: function(total){
        return {
              labels: ['Total volume', 'Daily volume', 'Percentage'],
              plotOptions: {
                  radialBar: {
                      size: 165,
                      offsetY: -5,
                      hollow: {
                          size: '20%'
                      },
                      track: {
                          background: "#ebebeb",
                          strokeWidth: '100%',
                          margin: 15,
                      },
                      dataLabels: {
                          show: true,
                          name: {
                              fontSize: '18px',
                          },
                          value: {
                              fontSize: '16px',
                              color: "#636a71",
                              offsetY: 11
                          },
                          total: {
                              show: true,
                              label: 'Percentage',
                              formatter: function() {
                                  return total
                              }
                          }
                      }
                  },
              },
              responsive: [{
                  breakpoint: 576,
                  options: {
                      plotOptions: {
                          radialBar: {
                              size: 150,
                              hollow: {
                                  size: '20%'
                              },
                              track: {
                                  background: "#ebebeb",
                                  strokeWidth: '100%',
                                  margin: 15,
                              },
                          }
                      }
                  }
              }],
              colors: ['#7961F9', '#FF9F43', '#EA5455'],
              fill: {
                  type: 'gradient',
                  gradient: {
                      // enabled: true,
                      shade: 'dark',
                      type: 'vertical',
                      shadeIntensity: 0.5,
                      gradientToColors: ['#9c8cfc', '#FFC085', '#f29292'],
                      inverseColors: false,
                      opacityFrom: 1,
                      opacityTo: 1,
                      stops: [0, 100]
                  },
              },
              stroke: {
                  lineCap: 'round'
              },
              chart: {
                  height: 355,
                  dropShadow: {
                      enabled: true,
                      blur: 3,
                      left: 1,
                      top: 1,
                      opacity: 0.1
                  },
              }
          }
      }
    }
}
</script>

<style lang="scss">
/*! rtl:begin:ignore */
#dashboard-analytics {
  .greet-user{
    position: relative;

    .decore-left{
      position: absolute;
      left:0;
      top: 0;
    }
    .decore-right{
      position: absolute;
      right:0;
      top: 0;
    }
  }

  @media(max-width: 576px) {
    .decore-left, .decore-right{
      width: 140px;
    }
  }
}
/*! rtl:end:ignore */
</style>
